import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const collapsibleTriggerVariants = tv({
  base: "flex w-full py-3 content-center cursor-pointer",
  variants: {
    root: {
      default: "pl-6 pr-3",
      root: "px-3 border-b"
    },
    disabled: {
      default: "",
      disabled: ""
    }
  },
  compoundVariants: [
    {
      root: "root",
      disabled: "default",
      class: "bg-(--bg-2)"
    },
    {
      root: "root",
      disabled: "disabled",
      class: "bg-(--gray-tag-1)"
    }
  ],
  defaultVariants: {
    root: "default"
  }
});
export {
  collapsibleTriggerVariants
};
//# sourceMappingURL=index.js.map
